module.exports = __webpack_public_path__ + "img/invite-members-btn.6cb77af5.webp";